import Vue from 'vue'
import { baseURL} from '@/shared/services/config'

/*
 * Valor especial de dominios.script_chat: em vez de baixar /js/chat/<nome>.js
 * (Zendesk, TomTicket...), o botao "Suporte" abre o assistente de IA do
 * ClickDesk que ja esta na tela (AssistenteDesk.vue). GCK-21244.
 */
export const SCRIPT_CHAT_ASSISTENTE = 'assistente'

/*
 * Mesmo id e mesmo markup do botao dos scripts do Zendesk: o CSS do
 * AdminLTE.css e o esconder/mostrar por rota (generico.js) continuam valendo.
 */
const criaBotaoAssistente = (abreAssistente) => {
    // Sem o assistente montado (layouts Externo, login, cadastro) o botao nao
    // teria o que abrir: melhor nao exibir nada.
    if (typeof abreAssistente !== 'function') {
        return false
    }
    if (document.getElementById('botao_suporte_zendesk')) {
        return true
    }
    const botaoSuporte = document.createElement('div')
    botaoSuporte.id = 'botao_suporte_zendesk'
    const botao = document.createElement('button')
    botao.type = 'button'
    botao.innerHTML = '<span class="mr-1 fa fa-comment"></span> Suporte'
    botao.addEventListener('click', () => abreAssistente())
    botaoSuporte.appendChild(botao)
    document.body.appendChild(botaoSuporte)
    return true
}

/*
 * Retorna se o botao de suporte vai existir na tela — quem chama so deve
 * esperar por ele (para esconder) quando for true.
 */
export const carregaScriptChat = ((abreAssistente = null) => {
    if (Vue.prototype.$app.script_chat === SCRIPT_CHAT_ASSISTENTE) {
        return criaBotaoAssistente(abreAssistente)
    }
    if(Vue.prototype.$app.script_chat){
        const s1 = document.createElement('script')
        const s0 = document.getElementsByTagName('script')[0]
        s1.async = true
        s1.src='/js/chat/' + Vue.prototype.$app.script_chat + '.js'
        s1.charset='UTF-8'
        try {  
            s1.setAttribute('cor_primaria', Vue.prototype.$app.cor_primaria)
            s1.setAttribute('cor_secundaria', Vue.prototype.$app.cor_secundaria)
            s1.setAttribute('cor_intranet', Vue.prototype.$app.cor_intranet)
            s1.setAttribute('cor_contabilidade', Vue.prototype.$app.cor_contabilidade)
            s1.setAttribute('url_api', baseURL)
            s1.setAttribute('url_base', Vue.prototype.$urlBase)
            s1.setAttribute('nome_usuario', Vue.prototype.$usuarioLogado['nome'] || '')
            s1.setAttribute('email_usuario', Vue.prototype.$usuarioLogado['email'] || '')
            s1.setAttribute('nome_loja', Vue.prototype.$usuarioLogado['Loja']['nome'] || '')
            s1.setAttribute('empresa_id', Vue.prototype.$usuarioLogado['Empresa']['id'] || '')
            s1.setAttribute('nome_dominio', Vue.prototype.$usuarioLogado['Dominio']['nome'] || '')
            s1.setAttribute('nome_plano', Vue.prototype.$empresaPlano['nome_plano'] || '')
            s1.setAttribute('duracao_plano', Vue.prototype.$empresaPlano['duracao'] || '')
        } catch (error) {
            error
        }
        s1.setAttribute('crossorigin','*')
        s0.parentNode.insertBefore(s1, s0)
        return true
    }
    return false
})

export const removeScriptChat = () => {
    const botaoSuporte = document.getElementById('botao_suporte_zendesk');
    if (botaoSuporte) {
        botaoSuporte.style.display = 'none'; 
    }
}

export const showScriptChat = () => { 
    const botaoSuporte = document.getElementById('botao_suporte_zendesk');
    if (botaoSuporte) {
        botaoSuporte.style.display = 'block'; 
    }
}